module.exports = __webpack_public_path__ + "img/Vector4.9a1abd75.svg";